import React from "react";
import styles from "./css/AICourseGeneratorModal.module.css";
import CustomSelectAI from "./CustomSelectAI";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import AICoursePreviewModal from "./AICoursePreviewModal";
import { handleErrorMessage } from "../../../redux/actions/groups";
import { useDispatch } from "react-redux";

export default function AICourseGeneratorModal({ open, onClose }) {
  const history = useHistory();
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  const [courseName, setCourseName] = React.useState("");
  // const [expectedDuration, setExpectedDuration] = React.useState("");
  const [courseDescription, setCourseDescription] = React.useState("");

  const [courseLevel, setCourseLevel] = React.useState("");
  const [numSections, setNumSections] = React.useState("");

  const [uploadedFiles, setUploadedFiles] = React.useState([]);

  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [previewLoading, setPreviewLoading] = React.useState(false);
  const [previewData, setPreviewData] = React.useState(null);

  const courseLevelOptions = [
    { label: "Kids Level", value: "kids" },
    { label: "Beginner Level", value: "beginner" },
    { label: "Intermediate Level", value: "intermediate" },
    { label: "Expert Level", value: "expert" },
    { label: "All Levels", value: "all" },
  ];

  const handleGenerate = async () => {
    if (!courseName) return dispatch(handleErrorMessage("Course name is required to generate a preview."));

    setPreviewOpen(true);
    setPreviewLoading(true);

    const safeSections = numSections
      ? Math.min(Math.max(Number(numSections), 1), 20)
      : undefined;

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/suggestions/generate-course-structure/`,
        {
          params: {
            course_topic: courseName,
            course_type: courseLevel,
            num_sections: safeSections,
            // expected_duration: expectedDuration,
            description: courseDescription
          },
          headers: {
            Authorization: `Token ${token}`
          }
        }
      );

      setPreviewData(res.data.data.parsed_data);
    } catch (err) {
      console.error(err);
      dispatch(handleErrorMessage("Error generating course preview. Please try again."));
      setPreviewOpen(false);
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleRemoveFile = (index) => {
    setUploadedFiles((prev) =>
      prev.filter((_, i) => i !== index)
    );
  };


  if (!open) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Close */}
        <button className={styles.closeBtn} onClick={onClose}>
          ×
        </button>

        {/* Header */}
        <div className={styles.header}>
          <div className={styles.headerIcon}>
            <img src="/Image/sparkle.svg" alt="AI" />
          </div>
          <h2>Create Your Custom Course with AI</h2>
          <p>
            Enter your course details and upload curriculum files.
            Our AI will generate a complete course instantly.
          </p>
        </div>

        <div className={styles.body}>
          {/* Course Name */}
          <div className={styles.field}>
            <label>
              Course Name <span>*</span>
            </label>
            <input
              type="text"
              placeholder="e.g., Advanced Machine Learning with TensorFlow"
              value={courseName}
              onChange={(e) => setCourseName(e.target.value)}
            />
          </div>

          <div className={styles.row}>
            {/* Course Level */}
            <div className={styles.field}>
              <label>Course Level</label>
              <CustomSelectAI
                name="courseLevel"
                value={courseLevel}
                options={courseLevelOptions}
                placeholder="Select level"
                onChange={(e) => setCourseLevel(e.target.value)}
              />
            </div>

            {/* Duration */}
            {/* <div className={styles.field}>
              <label>Expected Duration (hours)</label>
              <input
                type="number"
                placeholder="12"
                value={expectedDuration}
                onChange={(e) => setExpectedDuration(e.target.value)}
                min="1"
              />
            </div> */}

            {/* Sections */}
            <div className={styles.field}>
              <label>Number of Sections (Optional)</label>
              <input
                type="number"
                placeholder="e.g., 8"
                value={numSections}
                onChange={(e) => setNumSections(e.target.value)}
                min="1"
                max="20"
              />
            </div>
          </div>

          {/* Description */}
          <div className={styles.field}>
            <label>Course Description (Optional)</label>
            <textarea
              rows={4}
              placeholder="Add a custom description or let AI generate one for you..."
              value={courseDescription}
              onChange={(e) => setCourseDescription(e.target.value)}
            />
          </div>

          <div className={styles.field}>
            <label>Upload Curriculum Files (Optional)</label>
            <div
              className={styles.uploadBox}
              onClick={() => document.getElementById("ai-upload-input").click()}
            >
              <input
                type="file"
                multiple
                accept=".pdf,.doc,.docx,.txt,.ppt,.pptx"
                style={{ display: "none" }}
                id="ai-upload-input"
                onChange={(e) => {
                  const files = Array.from(e.target.files);

                  setUploadedFiles((prev) => {
                    const existingNames = prev.map((f) => f.name);
                    const filtered = files.filter(
                      (f) => !existingNames.includes(f.name)
                    );
                    return [...prev, ...filtered];
                  });

                  e.target.value = "";
                }}
              />
              <img src="/Image/upload-icon.svg" alt="upload" className={styles.uploadicon} />
              <p>Click to upload or drag and drop</p>
              <span>PDF, DOCX, TXT, PPT · Max 10 files</span>
            </div>
            {uploadedFiles.length > 0 && (
              <div className={styles.fileList}>
                {uploadedFiles.map((file, i) => (
                  <div key={i} className={styles.fileItem}>
                    <span>📄 {file.name}</span>
                    <button
                      className={styles.removeFileBtn}
                      onClick={() => handleRemoveFile(i)}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className={styles.aiBox}>
            <div className={styles.aiTitle}>
              <img src="/Image/sparkle-pink.svg" alt="" />
              <span>AI-Powered Course Generation</span>
            </div>

            <div className={styles.aiList}>
              <div className={styles.aiListItem}><img src="/Image/green-tick.svg" alt="✔" /> Complete module structure</div>
              <div className={styles.aiListItem}><img src="/Image/green-tick.svg" alt="✔" /> Detailed lecture content</div>
              <div className={styles.aiListItem}><img src="/Image/green-tick.svg" alt="✔" /> Practice exercises & quizzes</div>
              <div className={styles.aiListItem}><img src="/Image/green-tick.svg" alt="✔" /> Learning resources & materials</div>
            </div>
          </div>

          <div className={styles.footer}>
            <button className={styles.generateBtn} onClick={handleGenerate}>
              <img src="/Image/sparkle.svg" alt="" />
              Generate Course with AI
            </button>
          </div>
        </div>
      </div>
      <AICoursePreviewModal
        open={previewOpen}
        loading={previewLoading}
        data={previewData}
        uploadedFiles={uploadedFiles}
        onClose={() => setPreviewOpen(false)}
      />
    </div>
  );
}
